/** Strings owned by `src/manage/overview/` — "Beheer › Overzicht"
 * (PLAN-FASE3.md WP-05): the platform-staff-only KPI overview. No NPS or
 * AI-summary card — out of scope, see AdminOverviewPage.tsx. */
export const manageOverview = {
  page: {
    title: 'Genel Bakış',
    lead: 'Platform geneli anahtar rakamlar: gelir, aktif şirketler ve kullanıcılar ve elde tutma.',
    activeCompanies: 'Aktif şirketler',
    activeUsers: 'Aktif kullanıcılar',
    revenueThisMonth: 'Bu ayki gelir',
    retention: 'Elde tutma (aydan aya)',
    retentionUnavailable: 'Henüz veri yok',
    retentionDetail: '{{total}} şirketten {{retained}} tanesi elde tutuldu',
  },
} as const;
